<template>
    <div class="ck-upload-online">
        <el-dialog :close-on-click-modal="false"   :visible.sync="ckData.visible" title="多图上传" width="60%">
            <div style="margin: 20px 0px">
                <div class="img-list">
                    <draggable :animation='200' :list="imgUrls">
                        <transition-group style="display: flow-root">
                            <div class="online-img-body" v-for="(url,index) in imgUrls" :key="index" >
                                <el-row type="flex">
                                    <el-col :span="4">
                                        <div style="width: 50px;height: 50px;display: flex;justify-content: center;align-items: center">
                                            <el-image :src="url" fit="contain" style="width: 50px;">
                                                <div slot="error" class="image-slot">
                                                    <img src="../../../assets/images/kong.png" style="width: 50px;height: 50px"/>
                                                </div>
                                            </el-image>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-input size="small" style="width: 100%" v-model="imgUrls[index]" placeholder="请输入图片地址"></el-input>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button type="text" size="small" @click="removeImg(index)">删除</el-button>
                                    </el-col>
                                </el-row>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
                <el-row type="flex">
                    <el-col :span="4" style="padding-left: 50px">
                        <el-button type="primary" size="small" @click="imgUrls.push('')">继续添加</el-button>
                    </el-col>
                    <el-col :span="20" style="display: flex;align-items: center">
                        <div style="display: flex;font-size: 13px">
                            <div style="width:40px;text-align: center;background-color: #009999;margin-right: 10px;color: white"><span>说明</span></div>
                            <div>
                                <span>点击图片拖动，即可调整图片顺序!</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="pic-setting">
                <el-row type="flex">
                    <el-col :span="4"><span class="setting-name">图片大小</span></el-col>
                    <el-col :span="20">
                        宽：<el-input v-model.number="settings.width" size="small" style="width: 150px"></el-input><span class="setting-tip">根据已设置的图片宽度,等比例缩放高度</span>
                    </el-col>
                </el-row>
                <!--                <el-row type="flex">-->
                <!--                    <el-col :span="4"><span class="setting-name">文字环绕</span></el-col>-->
                <!--                    <el-col :span="20">-->
                <!--                        <el-radio-group v-model="settings.around">-->
                <!--                            <el-radio label="1">上下</el-radio>-->
                <!--                            <el-radio label="2">环绕</el-radio>-->
                <!--                        </el-radio-group>-->
                <!--                    </el-col>-->
                <!--                </el-row>-->
                <el-row type="flex">
                    <el-col :span="4"><span class="setting-name">对齐方式</span></el-col>
                    <el-col :span="20">
                        <el-radio-group v-model="settings.align">
                            <el-radio label="left">左对齐</el-radio>
                            <el-radio label="center">居中对齐</el-radio>
                            <el-radio label="right">右对齐</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="ckData.visible = false">取消</el-button>
                <el-button type="primary" size="small" @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import draggable from "vuedraggable"
    export default {
        name: "onlineUpload",
        props:{
            ckData:{
                type:Object,
                default:function () {
                    return{
                        visible:false,
                        editor:null
                    }
                }
            },
        },
        components:{draggable},
        data(){
            return{
                imgUrls:['','','',''],
                settings:{
                    width:null,//宽度
                    around:'1',//环绕方式
                    align:'left',//对齐方式
                }
            }
        },

        methods:{
            removeImg(index){
                this.imgUrls.splice(index,1);
            },
            submit(){
                let editor = this.ckData.editor;
                let around =this.settings.around;
                let align = this.settings.align;
                let width = this.settings.width;
                let element = CKEDITOR.dom.element.createFromHtml( '<p/>' );
                this.imgUrls.forEach(url =>{
                    console.log(url);
                    const p = CKEDITOR.dom.element.createFromHtml( '<p/>' );
                    p.setStyles({'margin':0,'display':'block','width':'100%'});
                    p.setStyle('text-align',align);
                    const imgHtml = CKEDITOR.dom.element.createFromHtml("<img/>");
                    imgHtml.setAttribute('src',url);
                    imgHtml.setAttribute('width',width);
                    imgHtml.setStyles({'object-fit':'contain'});
                    imgHtml.appendTo( p );
                    p.appendTo(element);
                });
                    editor.insertElement(element);
                this.ckData.visible = false;

            }
        }
    }
</script>

<style scoped>

</style>
